import React from "react";
import EmailLink from "./EmailLink";
import { Translations } from "../translations";

const HelpDeskEmailLink = () => (
  <EmailLink email={Translations.corp_emails.help_desk} />
);

export default HelpDeskEmailLink;
